import React, {forwardRef, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

interface ActivityWithIconProps {
  iconName: IconName;
  iconColor?: string;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledIconDiv = styled.div`
  margin-right: 2px;
`;

/*
 * Component.
 */

export const ActivityWithIcon = forwardRef<HTMLDivElement, PropsWithChildren<ActivityWithIconProps>>(
  (props, ref) => (
    <StyledDiv ref={ref}>
      {renderIcon(props)}
      {props.children}
    </StyledDiv>
  ),
);

/*
 * Helpers.
 */

function renderIcon(props: ActivityWithIconProps) {
  return (
    <StyledIconDiv>
      <Icon name={props.iconName} color={props.iconColor} size={12} />
    </StyledIconDiv>
  );
}
